export default __webpack_public_path__ + "static/media/icons-audience.ea3aba46.svg";